
export enum UserEventType {
    USER_UPDATED = "user.userUpdated",
}